import React from "react";
import { Form, Button, InputGroup, Container, Row, Col } from "react-bootstrap";
import { getFormulaElements, addTerm, addUniqueTerm, addOperator, addNumber, removeTag } from "presentation/pages/evaluation-schemes/elements/evaluation-formula/functions";

import Sortable from "presentation/pages/evaluation-schemes/elements/evaluation-formula/sortable";

import {
  arrayMove,
} from '@dnd-kit/sortable';

class EvaluationFormula extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      term: undefined,
      termId: undefined,
      number: undefined,
      operator: undefined,
      elements: [],
      show: true,
    };
  }

  componentDidMount() {
    let { existingElements } = this.props;

    if (existingElements) {
      this.setState({ elements: existingElements });
    }
  }

  doUpdateExpression = (elements) => {
    let { updateExpression, entityKey } = this.props;
    updateExpression(entityKey, elements);

  }

  handleAddNumber = () => {

    let { number, elements } = this.state;
    let newElements = addNumber(number, elements);


    this.doUpdateExpression(newElements);
    this.setState({ elements: newElements, number: "" });
  }


  handleChangeOperator = (e) => {
    let operator = e.target.value;
    let { elements } = this.state;
    let newElements = addOperator(operator, elements);

    this.doUpdateExpression(newElements);
    this.setState({ elements: newElements, operator: "" });
  }

  handleChangeTerm = (e) => {
    let termId = e.target.value;
    let { terms } = this.props;
    let { elements } = this.state;

    let termInfo = terms.filter(x => x.id == termId)[0];

    if (termInfo) {
      let newElements = termInfo.isUnique ? addUniqueTerm(termInfo, elements) : addTerm(termInfo, elements);

      this.doUpdateExpression(newElements);
      this.setState({ elements: newElements, term: "" });
    }

  }

  onRemove = (formulaId) => {
    let { elements } = this.state;
    let newElements = removeTag(formulaId, elements);

    this.setState({ elements: newElements });
  }

  handleDragEnd = (event) => {
    const { active, over } = event;
    let { elements } = this.state;


    if (active.id !== over.id) {
      const oldIndex = elements.findIndex(x => x.tokenId === active.id);
      const newIndex = elements.findIndex(x => x.tokenId === over.id);

      let newElements = arrayMove(elements, oldIndex, newIndex);

      this.doUpdateExpression(newElements);
      this.setState({ elements: newElements });
    }

  }

  render() {
    let { onRemove, handleDragEnd, handleChangeOperator, handleAddNumber, handleChangeTerm } = this;
    let { elements, operator, number, term } = this.state;
    let { terms, sortableKey } = this.props;
    const operators = ['+', '-', '*', '/', '(', ')'];

    let termsOptions = terms || [];

    return (

      <>
        <Container>
          <Row>
            <Col md={4}>
              <Form.Label>Termo</Form.Label>
              <Form.Select
                aria-label="Termos"
                value={term}
                onChange={(e) => handleChangeTerm(e)}
              >
                <option value=""></option>
                {termsOptions.map((e, i) => { return <option key={`term-${e.machineName}-${i}`} value={e.id}>{e.displayName}</option> })}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Operador</Form.Label>
              <Form.Select
                aria-label="Operadores"
                value={operator}
                onChange={(e) => handleChangeOperator(e)}
              >
                <option vaelu=""></option>
                {operators.map((e, i) => { return <option key={`operator-${e}-${i}`} value={e}>{e}</option> })}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Valor</Form.Label>
              <InputGroup>
                <Form.Control type="number" value={number} onChange={(e) => this.setState({ number: e.target.value })} /> &nbsp;
                <Button onClick={() => handleAddNumber()}>Adicionar</Button>
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <Sortable containerKey={sortableKey} elements={elements} onRemove={onRemove} handleDragEnd={handleDragEnd} />
            </Col>
          </Row>
        </Container>
      </>
    );

  };
}

export default EvaluationFormula;